import { AxiosResponse } from 'axios';

import {
  PaginatedNameFilterOptions,
  PaginatedList,
  ServiceResult,
  LeadPartnerDto,
  AddLeadPartnerProps,
  UpdateLeadPartnerStatusRequest,
} from '@project/types';
import { authNetworkService } from '@project/services';

import leadPartnerUrls from './lead-partner.urls';

const getLeadPartner = async (
  filter: PaginatedNameFilterOptions,
): Promise<PaginatedList<LeadPartnerDto>> => {
  const url = leadPartnerUrls.getPaginatedBlackListUrl(filter);

  return authNetworkService
    .get(url)
    .then(
      (apiResponse: AxiosResponse<ServiceResult<PaginatedList<LeadPartnerDto>>>) =>
        apiResponse.data.data,
    );
};

const addLeadPartner = async (formData: AddLeadPartnerProps) => {
  const url = leadPartnerUrls.getBaseUrl();

  return authNetworkService.post(url, formData);
};

const removeLeadPartner = async (leadPartnerId: string) => {
  const url = leadPartnerUrls.deleteUrl(leadPartnerId);

  return authNetworkService.delete(url);
};

const updateLeadPartnerStatus = async (leadPartnerId: string, disabled: boolean) => {
  const url = leadPartnerUrls.updateStatusUrl(leadPartnerId);
  const patchDto: UpdateLeadPartnerStatusRequest = {
    disabled,
  };

  return authNetworkService.patch(url, patchDto);
};

export default {
  getLeadPartner,
  addLeadPartner,
  removeLeadPartner,
  updateLeadPartnerStatus,
};
